<template>
    <div class="input-control composite-box">
        <div class="part part-left">
            <label class="label">{{leftControlLabel}}</label>
            <component :is="leftControl" v-bind="leftControlProps" :initial-value="initialLeftValue" ref="leftControl"
                       @valueChanged="reValidateValue" @keydownEnter="onLeftControlKeydownEnter"></component>
            <simple-dropdown :alignment="1" :dropdown-arrow="true" class="more-for-input" v-if="notMentionedSettable">
                <template v-slot:dropdownMenu>
                    <ul>
                        <li>
                            <button @click="setLeftControlValue(notMentionedValue)">Not Mentioned</button>
                        </li>
                    </ul>
                </template>
            </simple-dropdown>
        </div>
        <div class="symbol">-</div>
        <div class="part part-right">
            <label class="label">{{rightControlLabel}}</label>
            <component :is="rightControl" v-bind="rightControlProps" :initial-value="initialRightValue"
                       ref="rightControl" @valueChanged="reValidateValue"></component>
            <simple-dropdown :alignment="1" :dropdown-arrow="true" class="more-for-input" v-if="notMentionedSettable">
                <template v-slot:dropdownMenu>
                    <ul>
                        <li>
                            <button @click="setRightControlValue(notMentionedValue)">Not Mentioned</button>
                        </li>
                    </ul>
                </template>
            </simple-dropdown>
        </div>
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";
    import SimpleDropdown from "@/components/SimpleDropdown";

    export default {
        name: "CompositeBoxForRange",
        components: {SimpleDropdown},
        mixins: [InputControlBase],
        props: {
            leftControlLabel: String,
            leftControl: Object,
            leftControlProps: Object,
            leftProperty: String,
            rightControlLabel: String,
            rightControl: Object,
            rightControlProps: Object,
            rightProperty: String,
            notMentionedSettable: Boolean,
            notMentionedValue: {},
        },
        created() {
            this.value = this.value || null;
        },
        methods: {
            onLeftControlKeydownEnter() {
                this.$refs.rightControl.focus();
            },
            setInputValue(value) {
                if (value) {
                    const leftValue = value[this.leftProperty];
                    const rightValue = value[this.rightProperty];
                    this.setLeftControlValue(leftValue);
                    this.setRightControlValue(rightValue);
                } else {
                    this.$refs.leftControl.setInputValue(null);
                    this.$refs.rightControl.setInputValue(null);
                }
            },
            setLeftControlValue(value) {
                this.$refs.leftControl.setInputValue(value);
            },
            setRightControlValue(value) {
                this.$refs.rightControl.setInputValue(value);
            },

            focus() {
                this.$refs.leftControl.focus();
            },
            reValidateValue() {
                const leftValue = this.$refs.leftControl.getValue();
                const rightValue = this.$refs.rightControl.getValue();
                if (leftValue !== null || rightValue !== null) {
                    const v = {};
                    if (leftValue !== null) {
                        v[this.leftProperty] = leftValue;
                    }
                    if (rightValue !== null) {
                        v[this.rightProperty] = rightValue;
                    }
                    this.value = v;
                } else {
                    this.value = null;
                }
            }
        },
        data() {
            return {
                initialLeftValue: this.initialValue && this.initialValue[this.leftProperty],
                initialRightValue: this.initialValue && this.initialValue[this.rightProperty]
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "input-controls";

    .input-control.composite-box {
        display: flex;
        align-items: center;
        padding-top: 1.1rem;

        .part {
            position: relative;
            flex: 1 1 50%;

            .label {
                position: absolute;
                top: 0;
                left: 0;
                margin-top: -1.1rem;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 600;
                color: #777777;
                font-size: 0.95em;
                margin-left: 0.25rem;
            }

            .input-control {
                width: 100%;
            }
            &:hover {
                .more-for-input {
                    visibility: visible;
                }
            }
        }

        .symbol {
            margin: 0 0.25rem;
            font-weight: bold;
        }

        .more-for-input {
            position: absolute;
            right: 0;
            top: 0;
            margin-right: 0.25rem;
            margin-top: 0.2rem;
            visibility: hidden;

            &.active {
                visibility: visible;
            }
        }
    }
</style>
